var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submitForm()
        }
      }
    },
    [
      _vm.isSuccess
        ? _c("b-alert", { attrs: { show: "", variant: "success" } }, [
            _vm._v(_vm._s(_vm.$t("auth.successResetPassword")))
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSuccess
        ? _c(
            "b-row",
            [
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("auth.userName"),
                    error: _vm.$v.model.userName,
                    md: "12",
                    lg: "12"
                  }
                },
                [
                  _c("NextInput", {
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("auth.userName")
                    },
                    model: {
                      value: _vm.model.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "userName", $$v)
                      },
                      expression: "model.userName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("auth.oldPassword"),
                    error: _vm.$v.model.oldPassword,
                    md: "12",
                    lg: "12"
                  }
                },
                [
                  _c("NextInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("auth.oldPassword")
                    },
                    model: {
                      value: _vm.model.oldPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "oldPassword", $$v)
                      },
                      expression: "model.oldPassword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("auth.password"),
                    error: _vm.$v.model.password,
                    md: "12",
                    lg: "12"
                  }
                },
                [
                  _c("NextInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("auth.newPassword")
                    },
                    model: {
                      value: _vm.model.password,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "password", $$v)
                      },
                      expression: "model.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("auth.rePassword"),
                    error: _vm.$v.model.rePassword,
                    md: "12",
                    lg: "12"
                  }
                },
                [
                  _c("NextInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("auth.reNewPassword")
                    },
                    model: {
                      value: _vm.model.rePassword,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "rePassword", $$v)
                      },
                      expression: "model.rePassword"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "text-center" },
        [
          !_vm.isSuccess
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c(
                        "b-alert",
                        { attrs: { show: "", variant: "danger" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("insert.settings.passwordExpire"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        id: "forgot-password-button",
                        type: "submit",
                        disabled: _vm.isLoading
                      }
                    },
                    [
                      !_vm.isLoading
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("auth.resetPassword")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isLoading ? _c("b-spinner") : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "my-3", attrs: { cols: "12" } },
            [
              _c("router-link", { attrs: { to: { name: "Login" } } }, [
                _vm._v(_vm._s(_vm.$t("auth.login")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3a9db54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a9db54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/reset-password.vue
// module id = null
// module chunks = 